
import { Routes } from '@angular/router';
import { authGuardGuard } from './guards/auth-guard.guard';
import { layoutRoutes } from './layout/layout.routes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  // Public routes with layout (header/footer)
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then(m => m.LayoutComponent),
    children: [
      { 
        path: 'home', 
        title: 'Home - Mosaic',
        loadComponent: () => import('./pages/landing/landing.page').then(m => m.LandingPage) 
      },
      { 
        path: 'practitioners', 
        title: 'Practitioners - Mosaic',
        loadComponent: () => import('./pages/practitioners/practitioners.page').then(m => m.PractitionersPage) 
      },
      { 
        path: 'contact', 
        title: 'Contact - Mosaic',
        loadComponent: () => import('./pages/contact/contact.page').then(m => m.ContactPage) 
      },
      { 
        path: 'results', 
        title: 'View Results - Mosaic',
        loadComponent: () => import('./pages/results/results.page').then(m => m.ResultsPage) 
      },
      { 
        path: 'order-kit', 
        title: 'Order Kit - Mosaic',
        loadComponent: () => import('./pages/order-kit/order-kit.page').then(m => m.OrderKitPage) 
      },
      { 
        path: 'create-account', 
        title: 'Create Account - Mosaic',
        loadComponent: () => import('./pages/create-account/create-account.page').then(m => m.CreateAccountPage) 
      },
      { 
        path: 'register-kit', 
        title: 'Register Kit - Mosaic',
        loadComponent: () => import('./pages/register-kit/register-kit.page').then(m => m.RegisterKitPage) 
      },
      { 
        path: 'profile', 
        title: 'My Profile - Mosaic',
        loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage) 
      },
      { 
        path: 'success', 
        title: 'Success - Mosaic',
        loadComponent: () => import('./pages/success/success.page').then(m => m.SuccessPage) 
      },
    ]
  },
  // Protected routes with main layout
  ...layoutRoutes,
  // Auth routes (with layout to match reference image)
  {
    path: 'login',
    title: 'Login - Mosaic',
    loadComponent: () => import('./layout/layout.component').then(m => m.LayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./auth/login/login.component').then((m) => m.LoginComponent),
      }
    ]
  },
  {
    path: 'forgot-password',
    title: 'Forgot Password - Mosaic',
    loadComponent: () => import('./layout/layout.component').then(m => m.LayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>import('./auth/forgot-password/forgot-password.component').then(
          (m) => m.ForgotPasswordComponent
        ),
      }
    ]
  },
  { path: '**', redirectTo: '/home' }
];
